export const READ_COMPLIANCE_REGISTRY_DOCUMENTS = 'PEOPLE_MANAGEMENT_POLICY_READ';
export const UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS = 'PEOPLE_MANAGEMENT_POLICY_UPLOAD';
export const UPDATE_COMPLIANCE_REGISTRY_DOCUMENTS = 'PEOPLE_MANAGEMENT_POLICY_UPLOAD';
export const DOWNLOAD_COMPLIANCE_REGISTRY_DOCUMENTS = 'PEOPLE_MANAGEMENT_POLICY_DOWNLOAD';
export const TARGET_AUDIENCE_ALL_EMPLOYEES = 'All workers';

export const COMPLIANCE_DOCUMENT_TYPES = {
  policy: 'policy',
  informational_document: 'informational_document',
  exception: 'exception',
} as const;

export const COMPLIANCE_DOCUMENT_TYPE_VALUES = {
  policy: 'Policy',
  informational_document: 'Informational document',
  exception: 'Exception',
};

export const COMPLIANCE_DOCUMENT_STATUS = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
};

export const COMPLIANCE_DOCUMENT_STATUS_VALUES = {
  UNPUBLISHED: 'Unpublished',
  PUBLISHED: 'Published',
};

export const GRACE_PERIOD_DAYS = {
  7: '1 week',
  14: '2 weeks',
  30: '1 month',
};

export const COMPLIANCE_REGISTRY_DOCUMENT_TYPE_OPTIONS = Object.entries(COMPLIANCE_DOCUMENT_TYPE_VALUES).map(
  ([value, label]) => ({
    label,
    value,
  }),
);
